import { SharedFileRequestContextType } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";

export enum CreateRequirementDefinitionSharedFileMimeType {
  All = "all",
  Image = "image",
  Document = "document",
  Other = "other"
}

export type CreateRequirementDefinitionSharedFilePartialForm = {
  instructions?: string;
  contextType?: SharedFileRequestContextType;
  mimeTypes: Partial<
    Record<CreateRequirementDefinitionSharedFileMimeType, boolean>
  >;
};
